/*jshint esversion: 6 */
import Ajax from '../../common/Ajax';

export default (function(config){

    let regionSelect = document.getElementsByClassName('region_select')[0];
    let countrySelect = document.getElementsByClassName('country_select')[0];

    regionSelect.onchange = function(){

        let option = this.options[this.selectedIndex];

        let route = '/';
        if(config.env === 'dev'){
            //route = '/app_dev.php/';
        }

        route = route + config.locale + '/widget/search/region/' + option.value + '/countries';

        countrySelect.innerHTML = '<option value="">Loading ... </option>';
        countrySelect.disabled = true;

        Ajax.getRequest(route, function(response){

            var html = '';
            for (var prop in response) {
                if (response.hasOwnProperty(prop)) {
                    html = html + "<option value='" + prop + "'>" + response[prop] + "</option>";
                }
            }

            countrySelect.innerHTML = html;
            countrySelect.disabled = false;

        });

    };

});


